import { useEffect, useRef, useState } from 'react';

interface IMIState {
    subscribe: (prop: string, callback: (newState: any, oldState: any) => void) => void;
    getState: (prop?: string) => any;
}

export function useMIState() {
    //@ts-ignore
    const MIState = useRef<IMIState>(window.MI.state);
    const state = useRef<any>();

    useEffect(() => {
        MIState.current.subscribe('', (newState, oldState) => {
            state.current = MIState.current.getState();
        });
        state.current = MIState.current.getState();
    }, [MIState]);

    return state.current;
}

export function useMIStateInComponent() {
    const stateInterval = useRef(0);
    const [state, setState] = useState<any>({});
    const stateRef = useRef(state);
    useEffect(() => {
        stateRef.current = state;
    }, [state]);
    useEffect(() => {
        stateInterval.current = window.setInterval(() => {
            //@ts-ignore
            const newState = window?.MI?.state?.state ?? null;
            if (newState && JSON.stringify(stateRef.current) != JSON.stringify(newState)) {
                setState(structuredClone(newState));
            }
        }, 250);
        return () => window.clearInterval(stateInterval.current);
    }, []);
    return state;
}
